import _objectSpread from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _typeof from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _classCallCheck from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import { BaseTransformer } from './BaseTransformer';
export var ActProjectTransformer = /*#__PURE__*/function (_BaseTransformer) {
  _inherits(ActProjectTransformer, _BaseTransformer);
  var _super = _createSuper(ActProjectTransformer);
  function ActProjectTransformer() {
    _classCallCheck(this, ActProjectTransformer);
    return _super.apply(this, arguments);
  }
  _createClass(ActProjectTransformer, null, [{
    key: "fetch",
    value: function fetch(data, users) {
      var followers = data.followers;
      var record_owner = data.record_owner;
      if (users) {
        // console.log("followers 1>",followers)
        if (followers && users && _typeof(followers) == "object" && followers[0]) {
          data.followers = followers.map(function (u) {
            var user = users.find(function (uf) {
              return "U" + uf.value == u.id;
            });
            if (user) {
              u.letters = user.firstname ? user.firstname.substring(0, 1) + user.lastname.substring(0, 1) : '';
              u.value = parseInt(u.id.substr(1));
              u.id = parseInt(u.id.substr(1));
              u.photo = user ? user.photo : '';
              u.full_name = user ? user.fullName : '';
              return u;
            } else {
              u.value = parseInt(u.id.substr(1));
              var lastname = u.label.split(" ")[1];
              u.letters = u.label ? u.label.substring(0, 1) + (lastname ? lastname.substring(0, 1) : '') : '';
              return u;
            }
          });
        }
        if (data.record_owner && users) {
          var ro = users.find(function (uf) {
            return uf.value == data.record_owner.value;
          });
          ro = _objectSpread({}, ro);
          if (ro) {
            ro.letters = ro.firstname ? ro.firstname.substring(0, 1) + ro.lastname.substring(0, 1) : '';
            ro.value = data.record_owner.value;
            ro.full_name = data.record_owner.label;
            data.record_owner = ro;
          }
        }
      }
      return {
        avatarType: data.avatar_type,
        projectColor: data.project_color,
        avatarIcon: data.avatar_icon,
        avatarImage: data.avatar_image,
        avatarImagePath: "data/act/project/".concat(data.record_id, "/avatar_image/content"),
        approvalRequired: data.approval_required ? true : false,
        useThreads: data.use_threads ? true : false,
        useSections: data.use_sections ? true : false,
        sectionRequired: data.section_required ? true : false,
        timeEntryRequired: data.time_entry_required ? true : false,
        accountName: data.account_name,
        projectName: data.project_name,
        projectStatus: data.project_status,
        projectGroup: data.project_group,
        startDate: data.start_date,
        dueDate: data.due_date,
        followUpOn: data.follow_up_on,
        recordOwner: {
          value: data.record_owner && data.record_owner.value ? data.record_owner.value : null,
          label: data.record_owner && data.record_owner.label ? data.record_owner.label : null,
          letters: data.record_owner && data.record_owner.letters ? data.record_owner.letters : null,
          photo: data.record_owner && data.record_owner.photo ? data.record_owner.photo : null
        },
        team: data.team ? data.team.value : null,
        teamLabel: data.team ? data.team.label : '',
        followers: data.followers ? data.followers : [],
        completedTaskRate: data.completed_tasks_rate,
        openTasks: data.open_tasks,
        openTaskAssignees: data.open_task_assignees,
        openTaskDuration: data.open_task_duration,
        overdueTasks: data.overdue_tasks,
        overdueTaskAssignees: data.overdue_task_assignees,
        overdueTaskDuration: data.overdue_task_duration,
        dependentTaskAssignees: data.dependent_task_assignees,
        dependentTaskDuration: data.dependent_task_duration,
        lastUpdateDate: data.last_update_date,
        lastUpdateMessage: data.last_update_message,
        createdOn: data.created_on,
        createdBy: data.created_by,
        lastModifiedOn: data.last_modified_on,
        lastModifiedBy: data.last_modified_by,
        description: data.description,
        recordId: data.record_id
      };
    }
  }, {
    key: "send",
    value: function send(data) {
      // console.log("data.followers",data.followers)
      return {
        record_id: data.recordId,
        account_name: data.accountName && data.accountName.value ? data.accountName.value : null,
        project_name: data.projectName,
        project_status: data.projectStatus && data.projectStatus.value ? data.projectStatus.value : null,
        project_group: data.projectGroup && data.projectGroup.value ? data.projectGroup.value : null,
        start_date: data.startDate,
        due_date: data.dueDate,
        follow_up_on: data.followUpOn,
        approval_required: data.approvalRequired,
        use_threads: data.useThreads,
        use_sections: data.useSections,
        section_required: data.sectionRequired,
        time_entry_required: data.timeEntryRequired,
        record_owner: data.recordOwner && data.recordOwner.value ? data.recordOwner.value : null,
        team: data.team,
        followers: data.followers ? data.followers.map(function (a) {
          return a ? a.value ? 'U' + a.value : 'U' + a : '';
        }) : data.followers,
        description: data.description
      };
    }
  }]);
  return ActProjectTransformer;
}(BaseTransformer);